export default function About() {
  return (
    <section id="about" className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-16 items-start">
          <div className="lg:col-span-2">
            <div className="inline-block px-4 py-2 bg-purple-100 rounded-full mb-6">
              <span className="text-sm font-semibold text-purple-700 uppercase tracking-wide">About Us</span>
            </div>
            <h2 className="text-5xl font-bold text-gray-900 leading-tight">
              Protecting Privacy<br />
              Since Day One
            </h2>
          </div>

          <div className="lg:col-span-3 space-y-6">
            <p className="text-lg text-gray-600 leading-relaxed">
              ESCRITORIO BENDER LTDA is dedicated to providing cutting-edge digital security solutions that empower individuals and businesses to navigate the online world with complete confidence. Our VPN service represents years of expertise in cybersecurity and a deep commitment to protecting your digital freedom.
            </p>
            <p className="text-lg text-gray-600 leading-relaxed">
              Based in Brazil, we understand the importance of privacy in an increasingly connected world. Our mission is to deliver enterprise-grade security technology that's accessible to everyone, ensuring that your online activities remain private, secure, and unrestricted.
            </p>

            <div className="mt-12 p-8 bg-purple-50 rounded-2xl border border-purple-100">
              <h3 className="text-xl font-bold text-gray-900 mb-6">Contact Information</h3>
              <div className="space-y-4">
                <div className="flex items-start gap-4">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-mail-line text-xl text-purple-600"></i>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-gray-500">Email</p>
                    <a href="mailto:info@escritoriobenderltda.com" className="text-base text-gray-900 hover:text-purple-600 transition-colors">
                      info@escritoriobenderltda.com
                    </a>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-phone-line text-xl text-purple-600"></i>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-gray-500">Phone</p>
                    <a href="tel:+14435644613" className="text-base text-gray-900 hover:text-purple-600 transition-colors">
                      +1 443 564 4613
                    </a>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-map-pin-line text-xl text-purple-600"></i>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-gray-500">Address</p>
                    <p className="text-base text-gray-900">
                      Av. CUJUBIM 2061<br />
                      CUJUBIM, Brazil<br />
                      76864-000
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
